<template>
  <div class="form-link-npa">
    <v-btn class="btn-add-category" @click.native.stop="personDialog = true">
      <span class="pro-icon-add"></span>
    </v-btn>
    <v-dialog v-model="personDialog" max-width="400">
      <v-card class="modal">
        <div class="modal-head">
          {{ $t('Контактные лица') }}
          <v-btn color="modal-close" @click.native="personDialog = false">
            <span class="pro-icon-close1"></span>
          </v-btn>
        </div>
        <div
          class="modal-body"
        >
          <div :class="{invalid: $v.fullName.$error}">
            <v-text-field
              v-model="person.fullName"
              outlined
              rounded
              dense
              ref="nameField"
              placeholder="ФИО"
            />
          </div>
          <div :class="{invalid: $v.position.$error}">
            <v-text-field
              v-model="person.position"
              outlined
              rounded
              dense
              ref="positionField"
              placeholder="Должность"
            />
          </div>
          <div :class="{invalid: $v.phone.$error}">
            <v-text-field
              v-model="person.phone"
              outlined
              rounded
              dense
              ref="phoneField"
              placeholder="Номер телефона"
            />
          </div>
          <v-btn rounded color="primary" dark @click="fetchPersons">
            {{ $t('Добавить') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <ul class="link-list">
      <li v-for="(item, index) of personList" :key="index">
        <a :href="item" target="_blank" class="link-npa">{{ item }}</a>
        <span class="pro-icon-close" @click="deletePerson(index)"></span>
      </li>
    </ul>
  </div>
</template>

<script>
  import { required } from 'vuelidate/lib/validators'

  export default {
    props: {
      authorData: {
        type: Object,
        required: false
      },
      personsLength: {
        type: Number,
        required: false
      }
    },
    data: () => ({
      person: {
        fullName: '',
        position: '',
        phone: '',
      },
      personList: [],
      personDialog: false
    }),
    validations: {
      fullName: { required },
      position: { required },
      phone: { required }
    },
    mounted: function() {
      if (this.$props.personsLength === 0) {
        this.person.fullName = this.$props.authorData.fullName
        this.person.position = this.$props.authorData.position
        this.person.phone = this.$props.authorData.phone
      }
    },
    watch: {
      personsLength(newVal) {
        if (newVal === 0 && this.authorData) {
          this.person.fullName = this.authorData.fullName;
          this.person.position = this.authorData.position;
          this.person.phone = this.authorData.phone;
        }
      }
    },
    methods: {
      fetchPersons () {
        this.personList.push(this.person)
        if (this.person.fullName && this.person.position && this.person.phone) {

        }

        // this.$refs.nameField.reset()
        // this.$refs.positionField.reset()
        // this.$refs.phoneField.reset()
        this.$emit('fetchPersons', this.personList)
      },
      resetPersons () {
        this.personList = []
        this.personDialog = false
      },
      deletePerson (index) {
        this.personList.splice(index, 1)
      }
    }
  }
</script>
